<script setup>
import { useLayout } from '@/layout/common/composables/layout';
import { provide, ref, watch } from 'vue';

const props = defineProps({
    collapsible: {
        type: Boolean,
        default: false
    }
});

const { layoutConfig } = useLayout();
const isOpen = ref(false);

const menuContext = {
    collapsible: props.collapsible,
    isOpen,
    toggle: () => {
        menuContext.isOpen.value = !menuContext.isOpen.value;
    },
    open: () => {
        menuContext.isOpen.value = true;
    },
    close: () => {
        menuContext.isOpen.value = false;
    }
};

watch(
    () => layoutConfig.menuState,
    (newState) => {
        if (newState === 'collapsed') {
            menuContext.close();
        }
    }
);

provide('menuContext', menuContext);
</script>

<template>
    <li :data-menu-collapsible="props.collapsible" class="group/menu-item relative" :class="props.class">
        <slot />
    </li>
</template>
